const crsList = {
  "http://www.opengis.net/def/crs/OGC/1.3/CRS84": "4326"
};

export default crsList;
